import React, { useState, useEffect } from 'react';

import * as Util from '../data/General';
import DashboardCards from '../components/widget/DashboardCards';

import * as Constants from './../store/index';
import Filter from '../components/widget/Filter';
import Card from '../components/widget/Card';
import Button from '../components/html/Button';
import ChartRequest from '../components/widget/ChartRequest';

import axios from "axios";
import { useStatistics } from '../hooks/useStatistics';

function Chatbot(props) {

  
  const [isChat, setIsChat] = useState(false);
  const [loading, setLoading] = useState(false);

  const setChat = (store) =>{
    const {moduleConfig} = store;
    let isSet = false;
    if(moduleConfig){
      for (let i = 0; i < moduleConfig.length; i++) {
        if (moduleConfig[i].name == "CHATBOT") {
          setIsChat(moduleConfig[i].active);
          isSet = true;
        }
      }
    }
    if(!isSet){
      setIsChat(null);
    }
    if(!isSet && window.location.href.indexOf("chatbot") > -1){
      setIsChat(false);
    }
  }
  
  const [tabs, setTabs] = useState(["Dashboard", "Configuración", "Entrenamiento"]);
  const [tabsSelected, setTabsSelected] = useState(0);
  const [secondMessage, setSecondMessage] = useState(20);
  const [secondSales, setSecondSales] = useState(100);
  const [message_send, setMessageSend] = useState(100);
  const [message_ready, setMessageReady] = useState(80);
  const [sales, setSales] = useState(100);
  const [salesAmount, setSalesAmount] = useState(100);
  const [roi, setRoi] = useState(100);  
  const [accountReturnPhone, setAccountReturnPhone] = useState("");
  
  let startDate = new Date();
  let endDate = new Date();
  startDate.setDate(endDate.getDate() - 60);
  
  const [filter, setFilter] = useState({
    fromNotifyDate: startDate.toLocaleDateString('en-CA', {year: 'numeric', month: '2-digit', day: '2-digit'}) + "T00:00:01",
    toNotifyDate: endDate.toLocaleDateString('en-CA', {year: 'numeric', month: '2-digit', day: '2-digit'})+ "T23:59:59"
  });
  const [url, setUrl] = useState("&fromDate=" +filter.fromNotifyDate + "&toDate="+filter.toNotifyDate);
  const [urlSpecial, setUrlSpecial] = useState("&fromDate=" +filter.fromNotifyDate + "&toDate="+filter.toNotifyDate);
 

  const updateFilter = (fil) => {
    setFilter(fil);
    setUrl("&fromNotifyDate=" +fil.fromNotifyDate + "&toNotifyDate="+fil.toNotifyDate+"&interval="+fil.interval);
    setUrlSpecial("&fromDate=" +fil.fromNotifyDate + "&toDate="+fil.toNotifyDate+"&interval="+fil.interval);
  }

  useEffect(() => {
    const store = Util.getAdminShop();
    setChat(store);
    if(store.plan.planType === "PLUS"){
      getAccount();
    }
  }, []);

  const getAccount = () =>{
    setLoading(true);
    let shop =  Util.getAdminShop();
    let newWA = {};
    if(shop && shop.marketingCredential){
      newWA.marketingCredential = shop.marketingCredential;
    }
    const url = window.url_server_2+"facebook/subaccount/?shop="+Util.getShopDomain();
    newWA["accessTokenStore"] = Constants.getAccessTokenStore();
    axios.post(url, newWA, {}).then(response => response.data,error => {
        return error;
      }).then((data) => {
        if (data && data.code === "200"){
          console.log(data);
          let account = JSON.parse(data.data);
          if(account.phone && account.phone !== "" ){
            setAccountReturnPhone(account.phone);
          }
        }else{
          alert("Ocurrio un error al obtener la cuenta, comuniquese con Revie!");
        }
        setLoading(false);
    });
  }


  const save = (value) => {
    setLoading(true);
    let shop = Util.getAdminShop();
    let {moduleConfig} = shop;
    let isSet = false;
    let isSetInbox  = false;
    if(moduleConfig){
      for (let i = 0; i < moduleConfig.length; i++) {
        if (moduleConfig[i].name == "CHATBOT") {
          moduleConfig[i].active = value;
          isSet = true;
        }else if (moduleConfig[i].name == "INBOX") {
          isSetInbox= true;
        }
      }
    }else{
      moduleConfig = [];
      moduleConfig.push({name: "INBOX", active: value});
      isSetInbox= true;
    }
    
    if(!isSet){
      moduleConfig.push({name: "CHATBOT", active: value});
    }
    if(value && isSetInbox === false){
      moduleConfig.push({name: "INBOX", active: value});
    }else if(value && isSetInbox === true){
      for (let i = 0; i < moduleConfig.length; i++) {
        if (moduleConfig[i].name == "INBOX") {
          moduleConfig[i].active = value;
        }
      }
    }
    shop.moduleConfig = moduleConfig;
    Util.setInfoShop(handleOkShop, handleOkShoperror, shop);
  }

  const handleOkShoperror = (data) => {
      console.log(data);
  }

  const handleOkShop = (data) => {
    if (data && data.id){
        localStorage.setItem(Constants.storage.USER_SHOP, JSON.stringify(data));
        setChat(data);
    }
    setLoading(false);
  }

  const active = () =>{
    save(true);
  }

  const inactive = () => {
    save(false);
  }
  const setDataUrl = (data) => {
    alert("Acción realizada con éxito!");
  }

  const inyectButton = (action, position) =>{
    if(accountReturnPhone && accountReturnPhone !== ""){
      Util.themeButtonWhatsapp(accountReturnPhone, action, position, setDataUrl, (data) => {});
    }else{
      let shop = Util.getAdminShop();
      let {id} = shop;
      if(id === "60770517158"){//richline
        Util.themeButtonWhatsapp("15206557686", action, position, setDataUrl, (data) => {});
      }
    }
  }

  const [total, setTotal] = useState(0);
  const [timeSaved, setTimeSaved] = useState(0);

  const [totalPrice, setTotalPrice] = useState(0);
  const [count, setCount] = useState(0);

  const dataOk = (data) => {
    //setData(data);
    console.log("data",data);
    let total = 0;
    if(data && data.length > 0){
        data.map((item, key) =>{
          total += item.count; 
        });
        setTotal(total);
        //1 Mensaje = 3.75 minutos
        setTimeSaved(((total*3.5)/60).toFixed(2));
    }else{
        setTotal(0);
        setTimeSaved(0);
    }
  }

  const dataOk2 = (data) => {
    //setData(data);
    console.log("data",data);
    let total = 0;
    if(data && data.mediumCount){
        setTotalPrice(data.totalPrice);
        setCount(data.mediumCount[0].count);
    }else{
        setCount(0);
        setTotalPrice(0);
    }
  }

  const {isLoad} = useStatistics({ urlInicial: "intervalstatistics?type=CHATBOT" + url, callback: dataOk, server: "inboxs/messages/"})
  const {isLoad2} = useStatistics({ urlInicial: "utmstatistics?utmSource=revie&utmMedium=ia" + url, callback: dataOk2, server: "orders/"})
  const USDollar = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
  });
  return (
    <div className='home'>
        {isChat ? 
        (
          <>
            <Filter isIntervalShow={false} setFilter={updateFilter} filter={filter} fromText="fromNotifyDate"  toText="toNotifyDate"/>
            <div className='content-flex space-between-start mobile-scroll flex-direction-column-mobile'>
              <DashboardCards title={Util.getMessage("analicts_campaign_2")} count={total} textTotal={Util.getMessage("analicts_campaign_2")} />
              <DashboardCards title={"TIEMPO AHORRADO"}  count={timeSaved} second={secondMessage} textTotal={"Horas"} />
              <DashboardCards title={Util.getMessage("analicts_campaign_3")} extra={(count) + " "+Util.getMessage("analicts_campaign_4")} count={USDollar.format(totalPrice)} textTotal={Util.getMessage("analicts_campaign_3")} />
            </div>
            <div className='analytics chatIA'>
              <ChartRequest title={"Mensajes respondidos por Lia"} typeValue="int" name={"WhatsApp"} typeLabel="date" delay={10} url={"inboxs/messages/intervalstatistics?type=CHATBOT" + url}/>
              <ChartRequest title={"Mensajes"} type="pie" listColors={{"CHAT":"#49A0FD","CHATBOT":"rgb(244, 165, 0)","MARKETING":"rgb(19, 153, 71)","REVIEW":"rgb(253, 87, 84)"}} pre_label="message_" typeLabel="traductor" name={"Reviews"} delay={150} url={"inboxs/messages/typestatistics?s=a" + urlSpecial} />
            </div>
            <div className='contect-chatbot-check' >
                <img src="img/ia/lia.png" alt="Ilustración Lia" />
                <div className='text-chatbox'>
                  <label className='title-chat'>{Util.getMessage("chatbothelp1")}</label>
                  <small>{Util.getMessage("chatbothelp2")}</small>
                  <Button disabled={loading} value={Util.getMessage("button_disable")} type="primary" onClick={() => inactive()}/>
                </div>
            </div>   

            <div className='contect-chatbot-check' >
                <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="Ilustración Lia" />
                <div className='text-chatbox'>
                  <label className='title-chat'>{Util.getMessage("chatbothelp3")}</label>
                  <small>{Util.getMessage("chatbothelp4")}</small>
                  <div className='button-whatsapp'>
                    <Button disabled={loading} value={Util.getMessage("chatbothelp5")} type="primary" onClick={() => inyectButton("add", "left")}/>
                    <Button disabled={loading} value={Util.getMessage("chatbothelp6")} type="primary" onClick={() => inyectButton("add", "right")}/>
                    <Button disabled={loading} value={Util.getMessage("chatbothelp7")}  onClick={() => inyectButton("remove", "right")}/>
                  </div>
                </div>
            </div>   
          </>
        ) : (
          <div className='cards-content-parent'>
              <div className='cards-content'>
                <Card 
                  img="img/ia/chatia-5.png"
                  title={Util.getMessage("chatbothelp8")}
                  subtitle={Util.getMessage("chatbothelp9")}
                  text={Util.getMessage("chatbothelp10")}
                />

                <Card 
                  img="img/ia/chatia-4.png"
                  title={Util.getMessage("chatbothelp11")}
                  subtitle={Util.getMessage("chatbothelp12")}
                  text={Util.getMessage("chatbothelp13")}
                />

                <Card 
                  img="img/ia/chatia-6.png"
                  title={Util.getMessage("chatbothelp14")}
                  subtitle={Util.getMessage("chatbothelp15")}
                  text={Util.getMessage("chatbothelp16")}
                />

                
            </div>
            <div className='cards-content'>
                <Card 
                  img="img/ia/chatia-3.png"
                  title={Util.getMessage("chatbothelp17")}
                  subtitle={Util.getMessage("chatbothelp18")}
                  text={Util.getMessage("chatbothelp19")}
                />

                <Card 
                  img="img/ia/chatia-2.png"
                  title={Util.getMessage("chatbothelp20")}
                  subtitle={Util.getMessage("chatbothelp21")}
                  text={Util.getMessage("chatbothelp22")}
                />

                <Card 
                  img="img/ia/chatia-1.png"
                  title={Util.getMessage("chatbothelp23")}
                  subtitle={Util.getMessage("chatbothelp24")}
                  text={Util.getMessage("chatbothelp25")}
                />
            </div>

            {isChat !== null ? ( 
              <div className='contect-chatbot-check'>
                  <img src="img/ia/lia.png" alt="Ilustración Lia" />
                  <div className='text-chatbox'>
                    <label className='title-chat'>{Util.getMessage("chatbothelp26")}</label>
                    <small>{Util.getMessage("chatbothelp27")}</small>
                    <Button disabled={loading} value={Util.getMessage("button_active")} type="primary" onClick={() => active()}/>
                  </div>
              </div>
            ) : (
              <div className='contect-chatbot-check'>
                  <img src="img/ia/lia.png" alt="Ilustración Lia" />
                  <div className='text-chatbox'>
                    <label className='title-chat' style={{marginBottom: "2rem"}}>{Util.getMessage("chatbothelp28")}</label>
                    <a href='https://calendly.com/renataraya/chatbot' className='btn-icon' target='_blank'>{Util.getMessage("chatbothelp29")}</a>
                  </div>
              </div>
            )}

          </div>
        )}

        
      <div>

      </div>
    </div>
  );
}

export default Chatbot;